import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import axios from 'axios';
import BountySubmissionItem from './BountySubmissionItem';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';

const BountySubmissions = () => {
  const dispatch = useDispatch()
    const {user} = useContext(AuthContext);
    const [submissions, setSubmissions] = useState([]);
          const { rowsPerPage } = useActionsContext();
    

    const getSubmissions = async () => {
        try {
          dispatch({type:'LOADING'})
            const data = new FormData();
            data.append('session', user.SessionId);
            data.append('limit', rowsPerPage);
            const response = await axios.post(`${ENDPOINT}admin-get-bounty-submissions.php`,data, SecurityHeaders);
            if (response.data.status === 'success') {
                setSubmissions(response.data.data);
                dispatch({type:'DONE_LOADING'})

            } else {
                console.error(response.data.message);
                dispatch({type:'ERROR',payload:response.data.message});
            }
        } catch (error) {
          dispatch({type:'ERROR',payload:error.message});
        }
    }
    
    useEffect(() => {
        getSubmissions();
    }, [rowsPerPage]);
    console.log(submissions);
  return (
   <>
    <div className="row">
    <div className="col-lg-12">
      <div className="table-responsive">
        <table className="table table-borderless align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Bounty</th>
              <th scope="col">Company</th>
              <th scope="col">Report</th>
              <th scope="col">Submission Time</th>
              
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
   {
    submissions?.map(submission => (
        <BountySubmissionItem item={submission} key={submission.id} reload={getSubmissions} />
    ))
   }
      </tbody>
        </table>
      </div>
      <div className="text-center mt-3">
        <a href="javascript:void(0);" className="text-success">
          <i className="mdi mdi-loading mdi-spin fs-20 align-middle me-2" /> Load more
        </a>
      </div>
    </div>
  </div>
   </>
  )
}

export default BountySubmissions
